/* eslint-disable no-unused-vars */
import {
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Typography,
} from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import { blue, green, grey, red } from "@mui/material/colors";
import ChairAltIcon from "@mui/icons-material/ChairAlt";
import EditIcon from "@mui/icons-material/Edit";
import CellEditor from "./CellEditor";
import { RowNodeSorter } from "@ag-grid-community/core";

export default function TerminalCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(translate("New Floor"));
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [rows, setRows] = useState(1);
  const [rowsError, setRowsError] = useState("");

  const [cols, setCols] = useState(1);
  const [colsError, setColsError] = useState("");

  const [layout, setLayout] = useState([]);
  const [showCellEditor, setShowCellEditor] = useState(false);
  const [currentCell, setCurrentCell] = useState();

  const [loadFlag, setLoadFlag] = useState([]);

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showTerminalCrudWindow: showTerminalCrudWindow,
  };

  async function buildGrid(r, c) {
    console.log(r, c);
    let layout = [];
    for (let i = 0; i < r + 2; i++) {
      let row = [];
      for (let j = 0; j < c + 2; j++) {
        row.push({
          name: String.fromCharCode(64 + i) + "" + j,
          chairs: 1,
          active: true,
        });
      }
      layout.push(row);
    }
    setLayout(layout);
  }

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  async function showTerminalCrudWindow(terminalId) {
    if (terminalId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
      await buildGrid(1, 1);
    } else {
      setMode("edit");
      populateTerminal(terminalId);
    }
  }
  async function populateTerminal(id) {
    {
      try {
        let { data } = await API.get("/api/v1/floor/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Floor data from server")
        );
      }
    }
  }

  async function populateData(bean, kotPrinters) {
    setWindowTitile(bean.name);
    setName(bean.name);
    if (bean.layoutRaw) {
      setLayout(JSON.parse(bean.layoutRaw));
    } else {
      await buildGrid(1, 1);
    }
    //setkotPrinter(p);

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete Floor") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/floor/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Terminal") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Floor"));
      }
    }
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        let result = await API.post("/api/v1/floor", payload);
        props.showMessage("success", translate("Saved Successfully"));
        //SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        console.log(err);
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Floor"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function getPolishedLayout(layout) {
    let l = [...layout];
    let rCount = 0;
    let nr = [];
    for (let row of l) {
      if (rCount != 0 && rCount != l.length - 1) {
        let co = [];
        let cCount = 0;
        for (let col of row) {
          if (cCount != 0 && cCount != row.length - 1) {
            co.push(col);
          }
          cCount++;
        }
        nr.push(co);
      }
      rCount++;
    }
    return nr;
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    saveObject["layoutRaw"] = JSON.stringify(layout);
    saveObject["layout"] = JSON.stringify(getPolishedLayout(layout));

    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }

    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function removeCell(rowIx, colIx) {
    let l = [...layout];
    l[rowIx][colIx].active = false;
    setLayout(l);
  }

  function activateCell(rowIx, colIx) {
    let l = [...layout];
    l[rowIx][colIx].active = true;
    setLayout(l);
  }

  function addRow(rowIx, colIx) {
    let l = [...layout];
    let row = [];
    for (let j = 0; j < l[0].length; j++) {
      row.push({
        name: String.fromCharCode(64 + l.length) + "" + j,
        chairs: 1,
        active: true,
      });
    }
    l.push(row);
    setLayout(l);
  }

  function addCol(rowIx, colIx) {
    let l = [...layout];
    console.log("Length" + l.length, String.fromCharCode(64 + l.length));
    let count = 0;
    for (let row of l) {
      row.push({
        name: String.fromCharCode(64 + count) + "" + row.length,
        chairs: 1,
        active: true,
      });
      count++;
    }
    setLayout(l);
  }

  function removeCol(rowIx, colIx) {
    console.log(rowIx, colIx);
    let l = [...layout];
    console.log("Length" + l.length, String.fromCharCode(64 + l.length));
    let ly = [];
    for (let row of l) {
      let rw = [];
      let count = 0;
      for (let c of row) {
        if (count != colIx) {
          rw.push(c);
        }
        count++;
      }
      ly.push(rw);
    }
    setLayout(ly);
  }

  function removeRow(rowIx, colIx) {
    let l = [...layout];
    console.log("Length" + l.length, String.fromCharCode(64 + l.length));
    let count = 0;
    let rw = [];
    for (let row of l) {
      if (rowIx != count) {
        rw.push(row);
      }
      count++;
    }
    setLayout(rw);
  }

  function editCell(rowIx, colIx) {
    setCurrentCell({ cell: layout[rowIx][colIx], colIx: colIx, rowIx: rowIx });
    setShowCellEditor(true);
  }

  function updateCell(rowIx, colIx, name, chairs) {
    console.log(rowIx, colIx, name, chairs);
    console.log(layout);

    let l = [...layout];
    l[rowIx][colIx].name = name;
    l[rowIx][colIx].chairs = chairs;
    setLayout(l);
  }

  const content = (
    <div>
      <Grid container spacing={"4px"}>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Name")} <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} sm={12}>
          Layout
        </Grid>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              {layout.map((rw, rowIx, rws) => {
                return (
                  <tr>
                    {rw.map((elem, colIx, cls) => {
                      if (rowIx == 0) {
                        if (colIx == 0) {
                          return <td style={{ width: "10px" }}></td>;
                        }
                        if (colIx == 1) {
                          return <td></td>;
                        }
                        if (colIx < cls.length - 1) {
                          return (
                            <td style={{ textAlign: "center" }}>
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  removeCol(rowIx, colIx);
                                }}
                              >
                                <ClearIcon style={{ color: red[900] }} />
                              </IconButton>
                            </td>
                          );
                        }
                        if (colIx == cls.length - 1) {
                          return (
                            <td style={{ width: "10px" }}>
                              <IconButton
                                aria-label="delete"
                                onClick={() => {
                                  addCol(rowIx, colIx);
                                }}
                              >
                                <AddIcon style={{ color: green[500] }} />
                              </IconButton>
                            </td>
                          );
                        }
                      }
                      if (colIx == 0 && rowIx == 1) {
                        return <td></td>;
                      }
                      if (colIx == 0 && rowIx < rws.length - 1) {
                        return (
                          <td>
                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                removeRow(rowIx, colIx);
                              }}
                            >
                              <ClearIcon style={{ color: red[900] }} />
                            </IconButton>
                          </td>
                        );
                      }

                      if (colIx == 0 && rowIx == rws.length - 1) {
                        return (
                          <td>
                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                addRow(rowIx, colIx);
                              }}
                            >
                              <AddIcon style={{ color: green[500] }} />
                            </IconButton>
                          </td>
                        );
                      }
                      if (colIx == cls.length - 1) {
                        return <td></td>;
                      }

                      if (rowIx == rws.length - 1) {
                        return <td></td>;
                      }

                      return (
                        <td style={{ textAlign: "center" }}>
                          <Card
                            sx={{
                              backgroundColor: elem.active
                                ? "#feff9c"
                                : grey[700],
                            }}
                          >
                            <CardContent
                              sx={{
                                padding: "2px",
                                "&:last-child": {
                                  paddingBottom: 0,
                                },
                              }}
                            >
                              {elem.active && (
                                <Grid container style={{ height: "70px" }}>
                                  <Grid
                                    item
                                    xs={4}
                                    style={{ textAlign: "left" }}
                                  >
                                    <IconButton
                                      onClick={() => {
                                        editCell(rowIx, colIx);
                                      }}
                                      aria-label="delete"
                                      style={{ fontSize: "10px" }}
                                    >
                                      <EditIcon
                                        style={{
                                          color: blue[500],
                                          fontSize: "20px",
                                        }}
                                      />
                                    </IconButton>
                                  </Grid>
                                  <Grid item xs={4}></Grid>
                                  <Grid
                                    item
                                    xs={4}
                                    style={{ textAlign: "right" }}
                                  >
                                    <IconButton
                                      aria-label="delete"
                                      style={{
                                        fontSize: "10px",
                                      }}
                                      onClick={() => {
                                        removeCell(rowIx, colIx);
                                      }}
                                    >
                                      <ClearIcon
                                        style={{
                                          color: blue[500],
                                          fontSize: "20px",
                                        }}
                                      />
                                    </IconButton>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={6}
                                    style={{
                                      paddingLeft: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {elem.name}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={6}
                                    style={{
                                      textAlign: "right",
                                      paddingRight: "10px",
                                    }}
                                  >
                                    <ChairAltIcon sx={{ fontSize: "15px" }} />
                                    {elem.chairs}
                                  </Grid>
                                </Grid>
                              )}
                              {!elem.active && (
                                <Grid container style={{ height: "70px" }}>
                                  <Grid item xs={12}>
                                    <IconButton
                                      aria-label="delete"
                                      style={{ fontSize: "10px" }}
                                      onClick={() => {
                                        activateCell(rowIx, colIx);
                                      }}
                                    >
                                      <AddIcon
                                        style={{
                                          color: blue[500],
                                          fontSize: "20px",
                                        }}
                                      />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              )}
                            </CardContent>
                          </Card>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"xl"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}

      {showCellEditor && (
        <CellEditor
          currentCell={currentCell}
          closeWindow={setShowCellEditor}
          updateCell={updateCell}
        ></CellEditor>
      )}
    </div>
  );
}
